import { render, staticRenderFns } from "./AccountType.vue?vue&type=template&id=9833ec18&scoped=true&"
import script from "./AccountType.vue?vue&type=script&lang=js&"
export * from "./AccountType.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9833ec18",
  null
  
)

export default component.exports